import UsersPage from '@/sections/users/summary/users-page';
import UserHistory from '@/sections/users/history/user-history';

export default [
	{
		name: 'user-history',
		path: '/users/:changedEntityId/history',
		props: route => ({
			orderBy: route.query.orderBy || 'timestamp',
			orderDirection: route.query.orderDirection || 'desc',
			search: route.query.search,
			minDatetime: route.query.minDatetime,
			maxDatetime: route.query.maxDatetime,
			changedByUserId: route.query.changedByUserId,
			SourceApplication: route.query.SourceApplication || 'VueSupport',
			entityType: route.query.entityType || 'UserExtended',
			changedEntityId: route.params.changedEntityId,
			recordStart: parseInt(route.query.recordStart) || 1,
			maxCount: parseInt(route.query.maxCount) || 10
		}),
		component: UserHistory,
		meta: {
			authorization:{
				permissions: ['users.read']
			}
		}
	},
	{
		name: 'users-manager',
		path: '/users',
		component: UsersPage,
		props: route => ({
			search: route.query.search,
			count: parseInt(route.query.count),
			sortBy: route.query.sortBy || 'name',
			sortDirection: route.query.sortDirection || 'asc',
			status: route.query.status,
			roleId: parseInt(route.query.roleId) || null,
			userId: route.query.userId,
			clientId: route.query.clientId,
		}),
		meta: {
			authorization:{
				permissions: ['users.read']
			}
		}
	}
];
